import { divideAccuracy, goWithdrawFun } from "@/lobby_common/utils/utils.js";
import { freeGoldWithdrawInfo } from "@/lobby_common/api/payment_gen";
export default {
  name: "mode19",
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      divideAccuracy,
      freeGold: {
        coded: 0,
        requireCode: 0,
        status: '',
        countdown: 0,
        upgradeVip1Amount: 0,
        canWithdrawAmount: [],
        hasFreeGoldWithdraw: false, // false 为首次提现
        denominator: 0
      },
      time: 0,
      timeTxt: '',
      timerDown: null,
      showTooltip: true,
    };
  },
  computed: {
    lang() {
      return this.$store.getters.getLang;
    },
    getUserCoins() {
      return this.$store.getters.getUserCoins;
    },
    userCoins() {
      return (this.getUserCoins?.wallets || []).reduce((acc, item) => {
        acc[item.coinCode] = item;
        return acc;
      }, {});
    },
    userData() {
      return this.$store.getters.user || {};
    },
    isWithdraw() {
      return this.userData.isWithdraw;
    },
    userCoinCode() {
      return this.userData.coinCode;
    },
    userCoinCodeObj(){ // 会员货币对象
      return this.userCoins[this.userCoinCode] || {}
    },
    userFreeAmount() {
      return this.userCoinCodeObj.experienceWallet ? Number(this.userCoinCodeObj.experienceWallet) : 0
    },
    userFreeSymbol() {
      return this.userCoinCodeObj.freeSymbol || this.userCoinCodeObj.symbol
    },
    userAccuracy() {
      return this.userCoinCodeObj.accuracy
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    btnTxt() {
      if(this.freeGold.status === 'FREE_GOLD_WITHDRAW_STATUS_CODE_NOT_ENOUGH') {
        return this.$t("Datalang.newly_Withdrawal_Accelerating")
      } else {
        return this.$t("Datalang.Menu_BTM_withdraw")
      }
    }
  },
  watch: {},
  async created() {
    this.$Bus.$on("updateExchangeStatus", () => {
      this.fetchData()
    });
    this.$Bus.$on("updateFreeExchange", () => {
      this.fetchData()
    });
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      freeGoldWithdrawInfo({
        coinCode: this.userCoinCode
      }).then(({ data, code }) => {
        if (code === 0) {
          const rawData = data ? { ...data } : {};
          const freeData = {
            ...rawData,
            coded: this.divideAccuracy(rawData.coded || 0, this.userAccuracy),
            requireCode: this.divideAccuracy(rawData.requireCode || 0, this.userAccuracy),
            hasFreeGoldWithdraw: rawData.hasFreeGoldWithdraw
          };
          this.freeGold = freeData;
          let denominator = this.freeGold.denominator;
          if (freeData.canWithdrawAmount &&
            freeData.canWithdrawAmount.length > 0 &&
            freeData.canWithdrawAmount[0]?.code !== undefined &&
            freeData.canWithdrawAmount[0]?.code !== null) {
            denominator = freeData.canWithdrawAmount[0].code
          }
          if (denominator != null && !isNaN(parseFloat(denominator))) {
            this.freeGold.denominator = this.divideAccuracy(Number(denominator), this.userAccuracy);
          } else {
            this.freeGold.denominator = this.divideAccuracy(0, this.userAccuracy);;
          }

          // 加速中显示倒计时
          this.time = Number(this.freeGold.countdown)
          if (this.freeGold.status === 'FREE_GOLD_WITHDRAW_STATUS_CODE_NOT_ENOUGH') {
            this.startTimeDown();
          }
        }
      });
    },
    startTimeDown() {
      if (this.timerDown) {
        clearInterval(this.timerDown);
        this.timerDown = null;
      }
      if (Number(this.time) <= 0) {
        return;
      }
      this.timerDown = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          // 刷新数据 2秒后刷新
          setTimeout(() => {
            this.fetchData();
          }, 2000);
          clearInterval(this.timerDown);
          this.timerDown = null;
          return;
        } else {
          const hours = String(Math.floor(this.time / 3600)).padStart(2, "0")
          const minutes = String(Math.floor((this.time % 3600) / 60)).padStart(2, "0")
          const seconds = String(this.time % 60).padStart(2, "0")
          this.timeTxt = `${hours}:${minutes}:${seconds}`
        }
      }, 1000);
    },
    goWithdraw(){
      this.$eventPost("home_free_coin_withdraw");
      goWithdrawFun(2)  // 免费金币
    },
  },
  activated() {
    this.showTooltip = true; // 视情况决定是否重新显示
    this.fetchData()
  },
  deactivated() {
    this.$Bus.$off("updateExchangeStatus")
    this.$Bus.$off("updateFreeExchange")
    clearInterval(this.timerDown);
    this.timerDown = null;
    this.showTooltip = false;
  }
};
